import React from "react";
import { useStyles } from "./WarningIconStyles";
import warning1 from "../../assets/CSC-warnings/1.png";
import warning2 from "../../assets/CSC-warnings/2.png";
import warning3 from "../../assets/CSC-warnings/3.png";
import warning4 from "../../assets/CSC-warnings/4.png";
import warning5 from "../../assets/CSC-warnings/5.png";

interface WarningIconProps {
  controlSubstance: number;
}

export const WarningIcon: React.FC<WarningIconProps> = ({
  controlSubstance,
}) => {
  const classes = useStyles();

  const warningImages = [warning1, warning2, warning3, warning4, warning5];
  const selectedImage = warningImages[controlSubstance - 1] || warning5;

  return (
    <img
      src={selectedImage}
      alt="Warning"
      className={classes.warningIcon}
    />
  );
};
